export default __webpack_public_path__ + "static/panel-mobile-c07be23b8606b1d91858184c9d7e8240.png";